import GradeForm from "../../components/Forms/GradeForm";
import MainGoal from "../../components/Forms/MainGoal";
import PrimaryCategory from "../../components/Forms/PrimaryCategory";
import BasicCard from "../BasicCard";

import Dummylayout from "../Dummylayout";

function PrimaryCategoryMain() {
    return (
        <>
        {/* <MainLayout/> */}
           <div> <Dummylayout/></div>
    
<div className="mx-5 pl-5">
            <BasicCard>
                <PrimaryCategory/>
               
            </BasicCard>
            </div>
        </>
    )
}
export default PrimaryCategoryMain;